import { c as _c } from "react/compiler-runtime";
import * as NavigationMenu from '@radix-ui/react-navigation-menu';
import { useTranslation } from 'react-i18next';
import { cn } from '@sola/ark-core/utils/helpers.ts';
import { ArkIcon } from '@sola/ark-icons/lib/ark-icon.tsx';
import type { NavLevel } from '../../molecules/nav-stack/nav-stack.tsx';
import { NavStack } from '../../molecules/nav-stack/nav-stack.tsx';
type MobileMenuProps = {
  navStack: NavLevel[];
  setNavStack: React.Dispatch<React.SetStateAction<NavLevel[]>>;
  onClose: () => void;
  onBack: () => void;
  mobileCloseButtonRef: React.RefObject<HTMLButtonElement | null>;
  mobileOpenButtonRef: React.RefObject<HTMLButtonElement | null>;
  showLogin?: boolean;
  children: React.ReactNode;
};
export const MobileMenu: React.FC<MobileMenuProps> = t0 => {
  const $ = _c(30);
  const {
    navStack,
    setNavStack,
    onClose,
    onBack,
    mobileCloseButtonRef,
    mobileOpenButtonRef,
    showLogin,
    children
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = ["priority"];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation(t1);
  const t2 = navStack.length === 1;
  const t3 = navStack.length > 1;
  let t4;
  if ($[1] !== t2 || $[2] !== t3) {
    t4 = cn("Header__mobile-nav flex px-comfy-xs py-comfy-lg items-center", {
      "justify-end": t2,
      "justify-between": t3
    });
    $[1] = t2;
    $[2] = t3;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== mobileOpenButtonRef || $[5] !== navStack.length || $[6] !== onBack || $[7] !== t) {
    t5 = Boolean(navStack.length > 1) && <button ref={mobileOpenButtonRef} className="flex items-center" type="button" aria-label={t("header.back")} onClick={onBack}><ArkIcon iconName="arrow-left" className="Header__nav-icon" /></button>;
    $[4] = mobileOpenButtonRef;
    $[5] = navStack.length;
    $[6] = onBack;
    $[7] = t;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t) {
    t6 = t("header.menu");
    $[9] = t;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <ArkIcon iconName="x-close" className="Header__nav-icon" />;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== mobileCloseButtonRef || $[13] !== onClose || $[14] !== t6) {
    t8 = <button ref={mobileCloseButtonRef} className="Header__nav-action flex items-center p-comfy-xs" type="button" title={t6} onClick={onClose}>{t7}</button>;
    $[12] = mobileCloseButtonRef;
    $[13] = onClose;
    $[14] = t6;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== children || $[17] !== t8) {
    t9 = <span className="flex items-center gap-snug-md md:gap-snug-xl lg:gap-comfy-sm">{children}{t8}</span>;
    $[16] = children;
    $[17] = t8;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] !== t4 || $[20] !== t5 || $[21] !== t9) {
    t10 = <div className={t4}>{t5}{t9}</div>;
    $[19] = t4;
    $[20] = t5;
    $[21] = t9;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  let t11;
  if ($[23] !== navStack || $[24] !== setNavStack || $[25] !== showLogin) {
    t11 = <NavStack stack={navStack} setStack={setNavStack} showMyAccountSection={showLogin} className="pb-roomy-sm" />;
    $[23] = navStack;
    $[24] = setNavStack;
    $[25] = showLogin;
    $[26] = t11;
  } else {
    t11 = $[26];
  }
  let t12;
  if ($[27] !== t10 || $[28] !== t11) {
    t12 = <NavigationMenu.Content className="Header__content Header__content--mobile flex flex-col" onPointerLeave={_temp}>{t10}{t11}</NavigationMenu.Content>;
    $[27] = t10;
    $[28] = t11;
    $[29] = t12;
  } else {
    t12 = $[29];
  }
  return t12;
};
function _temp(e) {
  return e.preventDefault();
}